export default __webpack_public_path__ + "00800697139e6ea710ee9e96cd18254f.svg";